import { render, staticRenderFns } from "./AppRegistreren.vue?vue&type=template&id=d0e008fa&scoped=true&"
import script from "./AppRegistreren.ts?vue&type=script&lang=ts&"
export * from "./AppRegistreren.ts?vue&type=script&lang=ts&"
import style0 from "./AppRegistreren.scss?vue&type=style&index=0&id=d0e008fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e008fa",
  null
  
)

export default component.exports